<template>
  <div :class="['header-body-container', isShowQuickSearch && $route.path !== '/' && 'quick-search-styl']">
    <div class="header-bot">
      <div class="home-content flex align_items_ctr" v-if="$route.path === '/'">
        <div class="text-box">
          <div class="main-title">全球智库发现系统</div>
          <div class="web-des">汇聚前沿研究成果 助力决策咨询参考 发挥建言献策研究 促进国际交流合作</div>
          <div class="search-box flex">
            <el-input placeholder="请输入内容" v-model="key" class="input-with-select" @keyup.enter.native="setSearchKey">
              <el-select v-model="searchCurPath" slot="prepend" placeholder="请选择">
                <el-option v-for="(item, index) in searchOptions" :label="item.label" :value="item.path" :key="index"></el-option>
              </el-select>
            </el-input>
            <div class="search-btn" @click="setSearchKey">搜索</div>
          </div>
        </div>
        <div class="topic-box flex">
          <div class="topic-item" v-for="(item, index) in topics" :key="index" @click="() => $router.push(`${item.path}?name=${item.name}`)">
            <img :src="require(`../assets/icons/${item.icon}.png`)" class="topic-icon" alt="" />
            <div class="topic-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div v-show="isShowQuickSearch && $route.path !== '/'" class="other-content flex align_items_ctr jc_ctr">
          <div class="search-box flex">
            <el-input placeholder="请输入内容" v-model="key" class="input-with-select" @keyup.enter.native="setSearchKey">
              <el-select v-model="searchCurPath" slot="prepend" placeholder="请选择">
                <el-option v-for="(item, index) in searchOptions" :label="item.label" :value="item.path" :key="index"></el-option>
              </el-select>
            </el-input>
            <div class="search-btn" @click="setSearchKey">搜索</div>
            <div class="cancel-btn pointer" @click="cancelSearch">取消检索</div>
          </div>
        </div>
      <Overlay :visible="isShowQuickSearch"></Overlay>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Overlay from '@/components/Overlay.vue'
import store from '@/store'
export default {
  name: '',
  data() {
    return {
      key: '',
      currentPath: '/',
      searchCurPath: '/search',
      searchOptions: [
        {
          label: '全部',
          path: '/search',
        },
        {
          label: '成果',
          path: '/achievements',
        },
        {
          label: '动态',
          path: '/dynamic',
        },
        {
          label: '专家',
          path: '/expert',
        },
        {
          label: '机构',
          path: '/organization',
        },
      ],
      topics: [
        {
          icon: 'pol',
          name: '政治',
          path: '/topics/politics',
        },
        {
          icon: 'eco',
          name: '经济',
          path: '/topics/economics',
        },
        {
          icon: 'tech',
          name: '科技',
          path: '/topics/technology',
        },
        {
          icon: 'cul',
          name: '教育',
          path: '/topics/teach',
        },
        {
          icon: 'social',
          name: '社会',
          path: '/topics/social',
        },
        {
          icon: 'env',
          name: '环境',
          path: '/topics/environment',
        },
        {
          icon: 'milt',
          name: '军事',
          path: '/topics/military',
        },
        {
          icon: 'health',
          name: '健康',
          path: '/topics/health',
        },
      ],
      isShowQuickSearch: false,
    }
  },
  computed: {
    ...mapState(['showQuickSearch', 'searchKey']),
  },
  components: { Overlay },
  mounted() {
    this.key = this.searchKey
  },
  methods: {
    setSearchKey() {
      let path = this.searchCurPath === '/' ? '/search' : this.searchCurPath
      if (this.$route.path !== '/') {
        this.isShowQuickSearch = !this.isShowQuickSearch
        this.$store.commit('setShowQuickSearch', this.isShowQuickSearch)
      }
      this.$router.push(`${this.searchCurPath}?key=${this.key}`)
      this.key = ''
    },
    cancelSearch() {
      this.isShowQuickSearch = false
      this.$store.commit('setShowQuickSearch', false)
      this.$store.commit('setSearchKey', '')
    },
  },
  watch: {
    showQuickSearch: {
      deep: true,
      handler(n, o) {
        this.isShowQuickSearch = n
      },
    },
  },
}
</script>
<style lang="less" scoped>
.quick-search-styl {
  position: fixed;
  top: 81px;
  z-index: 2000;
  width: 100%;
}
.header-bot {
  min-width: 1600px;
  /deep/.el-input__inner {
    height: 60px;
    border: none;
    background-color: #ffffff;
    border-radius: 0 50px 50px 0;
  }
  /deep/ .el-input-group__prepend {
    border: none;
    background-color: #ffffff;
    border-radius: 50px 0 0 50px;
  }
  /deep/.el-select {
    width: 110px;
    color: #03133d;
    .el-input__inner {
      padding-left: 28px;
    }
  }
  .search-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 96px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
    font-weight: bold;
    background: linear-gradient(160deg, #0c87f0 0%, #036fe2 100%);
    border-radius: 50px 50px 50px 50px;
  }
  .cancel-btn {
    position: absolute;
    right: -100px;
    top: 50%;
    transform: translateY(-50%);
  }
  .home-content {
    flex-direction: column;
    justify-content: center;
    height: 510px;
    padding: 0 8px;
    background-image: url(../assets/header/body_1.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;
    .text-box {
      margin: 0 auto;
      width: 1500px;
    }
    .main-title {
      font-size: 44px;
      color: #03133d;
    }
    .web-des {
      margin-top: 16px;
      font-size: 20px;
      color: #03133d;
      line-height: 28px;
    }
    .search-box {
      margin-top: 50px;
      width: 800px;
      position: relative;
    }

    .topic-box {
      position: absolute;
      bottom: -30px;
      .topic-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 132px;
        height: 100px;
        text-align: center;
        cursor: pointer;
        background: linear-gradient(45deg, #ffffff 0%, #f4f6f9 100%);
        box-shadow: 0px 4px 20px 0px rgba(3, 19, 61, 0.05);
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #ffffff;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
      .topic-icon {
        width: 48px;
        height: 48px;
        object-fit: cover;
      }
    }
  }

  .other-content {
    height: 180px;
    background-image: url(../assets/header/body_2.jpg);
    background-size: cover;
    background-position: 0 100%;
    background-repeat: no-repeat;
    .search-box {
      width: 1000px;
      position: relative;
    }
  }
}
</style>
<style lang="less">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.el-dropdown-menu {
  width: 100px;
}
.el-dropdown-menu__item {
  width: 100px;
}
</style>
